import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { arc as viemArcBase } from 'viem/chains'

import type { AppChain } from './chain.types'

export const arc = viemDefineChain({
  ...viemArcBase,
  ...chainConfig,
  // Public dRPC endpoint: wallets get it on add-network; core-stack apps (`include.public`)
  // also use it as the last read fallback after the proxy. The Vaults app overrides transports to the proxy only.
  rpcUrls: { default: { http: ['https://arc.drpc.org'] } },
  blockExplorers: {
    default: { name: 'Arc Explorer', url: 'https://explorer.arc.io' }
  },
  contracts: {
    multicall3: { address: '0xcA11bde05977b3631167028862bE2a173976CA11', blockCreated: 0 }
  }
}).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Arc',
    shortName: 'Arc',
    safeShortName: 'arc',
    morphoChainSlug: 'arc',
    defiLlamaSlug: 'arc',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://explorer.arc.io', name: 'Arc Explorer' },
    gasToken: { address: '0x3600000000000000000000000000000000000000', decimals: 6 },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0xF02615d094Fc02fC031C35fe705e175aA4653f20',
          startBlock: 1208685n
        },
        MorphoBlue: {
          address: '0x34CD04070dD72b14E241112F6d83812Df5Af7fCD',
          startBlock: 1208685n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x3b0eefaBfa22ec7CF2c73877ac16e78D76749f12',
          startBlock: 1208931n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x6C2FF5114E45b50bc7195c2F1f87C98cbdad62Cc',
          startBlock: 1208978n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x77788033B22CEaB8D51Ec8F9dFD4a40E54F380B0',
          startBlock: 5314109n
        },
        RegistryList: {
          address: '0xdEBC92370Cd74d55DA144116138681dbbb528765',
          startBlock: 1208978n
        },
        BluePublicAllocator: {
          address: '0x4c2ff4D792d0a03A0e461e4B9B00Bc812A0147C2',
          startBlock: 20322353n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
